var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['drop-zone', {active:_vm.draggingOver}]},[(_vm.draggingOver)?_c('div',{staticClass:"text-h1"},[_vm._v("Drop Files")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }